import React from 'react';
import { CardHeader } from '@europrocurement/flexy-components';
import { Box, Typography, useTheme } from '@mui/material';
import RequiredDocumentsTotal from './RequiredDocumentsTotal';

export type RequiredDocumentsHeadingProps = {
    currentCount: number;
    missingDocumentsCount: number;
    totalCount: number;
};

const RequiredDocumentsHeading: React.FunctionComponent<RequiredDocumentsHeadingProps> = function (
    props,
) {
    const { palette } = useTheme();
    const { missingDocumentsCount, currentCount, totalCount } = props;

    return (
        <CardHeader
            title="Documents requis"
            titleSx={{
                fontSize: '20px',
                lineHeight: '28px',
            }}
            border={false}
            headerSx={{
                paddingX: '32px',
                paddingBottom: '1em',
            }}
            sx={{
                paddingX: 0,
            }}
            childrenSx={{ paddingX: 0 }}
        >
            <Box>
                {totalCount > 0 && (
                    <>
                        <Typography
                            component="p"
                            variant="l2dbodyxs"
                            sx={{ color: 'text.gris50' }}
                        >
                            {currentCount}/{totalCount} documents
                        </Typography>
                        <RequiredDocumentsTotal
                            missingDocumentsCount={missingDocumentsCount}
                            totalCount={totalCount}
                            additionnalText="documents"
                        />
                    </>
                )}

                <Typography
                    component="p"
                    variant="l2dbodyxs"
                    sx={{ marginY: '8px', color: palette.text.gris50 }}
                >
                    Formats : .pdf .doc .jpg .xls - Poids maximum : 10Mo
                </Typography>
            </Box>
        </CardHeader>
    );
};

export default RequiredDocumentsHeading;
